/**
 * Complete the look (blocks/complete-the-look.liquid). The row arrives filled from print tags and
 * the piece's line; after load this asks Shopify for related products, which learn from browsing
 * and orders, and puts the ones that fit first: never the piece itself, never its garment type,
 * never sold out (the section already drops those). If Shopify has nothing, or the request fails,
 * the row stays as it arrived.
 */
class CompleteTheLook extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = 'true';
    this.#load();
  }

  async #load() {
    const { url, productId, productType = '' } = this.dataset;
    const limit = Number.parseInt(this.dataset.limit || '3', 10);
    const list = this.querySelector('[data-ctl-list]');
    if (!url || !list) return;

    let related = [];
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      related = [...doc.querySelectorAll('[data-ctl-related] [data-ctl-item]')].filter(
        (item) => item instanceof HTMLElement && item.dataset.productId !== productId && item.dataset.type !== productType
      );
    } catch {
      return;
    }
    if (!related.length) return;

    const seen = new Set();
    const items = [];
    for (const item of [...related, ...list.querySelectorAll('[data-ctl-item]')]) {
      if (!(item instanceof HTMLElement)) continue;
      const id = item.dataset.productId;
      if (!id || seen.has(id)) continue;
      seen.add(id);
      items.push(item.ownerDocument === document ? item : document.importNode(item, true));
      if (items.length >= limit) break;
    }
    if (items.length < 2) return;

    list.replaceChildren(...items);
    this.hidden = false;
  }
}

if (!customElements.get('complete-the-look')) {
  customElements.define('complete-the-look', CompleteTheLook);
}
